import React from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import { withI18next } from 'lib/i18n/withI18next'
import { hasLocizeTranslation } from 'lib/utils/locize'
import BackdropModal from 'components/portal/backdrop-modal'
import Icon, { ICONS, ICON_SIZE } from 'components/common/icon'
import Typo from 'constants/typography'
import SearchInput from 'components/checkout/pomelo-pins/search-input'
import FindThisItemAccordion from '../accordion'
import styles from './styles.scss'
import { getStoreLocationFromSearch } from '../utils'

const FindThisItemModal = ({
  productID,
  stockInfo,
  setShouldOpenStoreModal,
  setStoreAvailableFromSearch,
  shouldOpenStoreModal,
  t,
}) => (
  <BackdropModal isOpen={shouldOpenStoreModal}>
    <style jsx>{styles}</style>
    <div className="find-item-modal">
      <div className="find-item-modal__header">
        <Icon
          alt="close-icon"
          className="svg-close"
          src={ICONS.close}
          size={ICON_SIZE.medium}
          onClick={() => setShouldOpenStoreModal(false)}
        />
        <span className={Typo.subtitle1}>
          {hasLocizeTranslation(
            t,
            'PDP_STORE_MODAL_HEADER',
            'Pomelo Store Near You',
          )}
        </span>
      </div>
      {stockInfo.length ? (
        <div>
          <SearchInput
            geoUpdate={(geoData) =>
              getStoreLocationFromSearch({
                geoData,
                stockInfo,
                setStoreAvailableFromSearch,
              })
            }
            showUnavailable={() => setStoreAvailableFromSearch(stockInfo)}
            isFromCheckout={false}
          />
          <FindThisItemAccordion productID={productID} stockInfo={stockInfo} />
        </div>
      ) : (
        <div className="no-available-store">
          <Icon src={ICONS.store} size={ICON_SIZE.extraLarge} />
          <span
            className={clsx(Typo.subtitle1, 'no-available-store__description')}
          >
            {hasLocizeTranslation(
              t,
              'PDP_STORE_NOT_FOUNDED',
              'Sorry, this item is no longer available at any of our stores in your region',
            )}
          </span>
        </div>
      )}
    </div>
  </BackdropModal>
)

FindThisItemModal.defaultProps = {
  stockInfo: null,
}

FindThisItemModal.propTypes = {
  productID: PropTypes.number.isRequired,
  stockInfo: PropTypes.arrayOf(PropTypes.shape({})),
  setShouldOpenStoreModal: PropTypes.func.isRequired,
  setStoreAvailableFromSearch: PropTypes.func.isRequired,
  shouldOpenStoreModal: PropTypes.bool.isRequired,
  t: PropTypes.func.isRequired,
}

export default withI18next()(FindThisItemModal)
